if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.isProductSet()) {
          this.form.querySelector('[name=id]').disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('button[name="add"]');

        // This prevents the form from being submitted via the button before the JS is loaded
        this.submitButton.setAttribute('type', 'submit');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.addUrlParamsAsCartAttributes();
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (
            (this.isProductSet() && !this.componentsPicker.validateInputs())
            || this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.setAddingToCartState();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = this.prepareFormData();

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (this.cart && !response.status) {
                this.handleSuccessfulAddToCart(response, config.body);
              } else if (response.status) {
                this.handleUnsuccessfulAddToCart(response, config.body);
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
              }
            })
            .catch(e => {
              console.error(e);
              this.handleErrorMessage('Se produjo un error. Inténtalo de nuevo.')
            })
            .finally(() => this.removeAddingToCartState());
      }

      prepareFormData() {
        const formData = new FormData(this.form);

        if (this.isProductSet()) {
          formData.delete('form_type');
          formData.delete('product-id');
          formData.delete('id');
        }

        if (this.cart) {
          formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append('sections_url', window.location.pathname);
        }

        return formData;
      }

      handleSuccessfulAddToCart(response, formData) {
        if (!this.closest('quick-add-modal')) {
          this.cart.renderContents(response);
        } else {
          document.body.addEventListener(
              'modalClosed',
              () => setTimeout(() => this.cart.renderContents(response)),
              {once: true}
          );

          this.closest('quick-add-modal').hide(true);
        }

        let productVariantId = formData.get('id');
        if (!productVariantId && response.items && response.items.length) {
          productVariantId = response.items[0].variant_id;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          type: 'add',
          productVariantId,
          items: this.isProductSet() ? this.getSetComponentItems(formData) : null,
          cartData: response,
          isProductSet: this.isProductSet(),
        });
      }

      handleUnsuccessfulAddToCart(response, formData) {
        this.handleErrorMessage(response.description);

        // TODO What does this do?
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (soldOutMessage) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        }

        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          type: 'add',
          productVariantId: formData.get('id'),
          items: this.isProductSet() ? this.getSetComponentItems(formData) : null,
          errors: response.errors || response.description,
          message: response.message,
          isProductSet: this.isProductSet(),
        });
      }

      getSetComponentItems(formData) {
        const items = [];

        for (let i = 0; i < 10; i++) {
          if (!formData.get(`items[${i}][id]`)) {
            break;
          }

          const item = {
            id: formData.get(`items[${i}][id]`),
            quantity: formData.get(`items[${i}][quantity]`) || 1,
            properties: {}
          }

          for (const [key, value] of formData.entries()) {
            if (key.startsWith(`items[${i}][properties][`)) {
              const propertyKey = key.replace(`items[${i}][properties][`, '')
                  .replace(']', '');
              item.properties[propertyKey] = value;
            }
          }

          items.push(item)
        }

        return items;
      }

      setAddingToCartState() {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
      }

      removeAddingToCartState() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');

        this.querySelector('.loading__spinner').classList.add('hidden');

        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper = this.errorMessageWrapper
            || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      isProductSet() {
        return this.dataset.isProductSet;
      }

      get componentsPicker() {
        return this.closest('product-info').querySelector('components-picker');
      }

      addUrlParamsAsCartAttributes() {
        try {
          const allowed = ['am_land_creative', 'am_click_creative'];
          const urlParams = new URLSearchParams(window.location.search);
          urlParams.forEach((value, key) => {
            if (!allowed.includes(key)) {
              return;
            }

            if (this.isProductSet()) {
              this.componentsPicker.querySelector('top-size-picker')?.append(
                  this.makePropertyInput(`items[0][properties][_${key}]`, parseInt(value))
              );
              this.componentsPicker.querySelector('bottom-size-picker')?.append(
                  this.makePropertyInput(`items[1][properties][_${key}]`, parseInt(value))
              );
            } else {
              this.form.append(this.makePropertyInput(`properties[_${key}]`, parseInt(value)));
            }
          });
        } catch (e) {
            console.error('Error adding URL params as cart attributes:', e);
        }
      }

      makePropertyInput(name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.setAttribute('form', this.dataset.formId);

        return input;
      }
    }
  );

  customElements.define('components-picker', class extends HTMLElement {
    subtreeLoadedCallback() {
      const productForm = this.closest('product-info').querySelector('product-form');

      const isValid = this.validateComponents();
      if (!isValid) {
        this.style.display = 'none';
        productForm.style.display = 'none';

        return;
      }

      this.classList.add('initialized');

      this.topProduct = JSON.parse(this.querySelector('[data-top-product]').innerHTML);

      this.topSizePicker = this.querySelector('top-size-picker');
      this.topSizePicker.initialize(this.topProduct);

      this.bottomSizePicker = this.querySelector('bottom-size-picker');
      this.bottomSizePicker.initialize();

      this.addEventListener('change', () => this.updateSetProperties());
    }

    validateComponents() {
      // TODO - ensure we have everything we need in the form. If not, hide it.

      return true;
    }

    validateInputs() {
      const topIsValid = this.topSizePicker.validateInputs(true);
      const bottomIsValid = this.bottomSizePicker.validateInputs(true);
      const formIsValid = topIsValid && bottomIsValid;

      if (!formIsValid) {
        const visibleErrorElements = Array.from(this.querySelectorAll('.form__error-label'))
            .filter(error => !error.classList.contains('hidden'));

        if (!visibleErrorElements.length) {
          // In the off-chance that all the error labels are hidden (they should not be), show them all to force re-selection
          this.querySelectorAll('.form__error-label')
              .forEach(error => error.classList.remove('hidden'));
        }
      }

      return formIsValid;
    }

    updateSetProperties() {
      const topVariantSku = this.querySelector('[data-top-variant-sku]').value;
      const bottomVariantSku = this.querySelector('[data-bottom-variant-sku]').value;

      this.querySelectorAll('[data-set-property]')
          .forEach(input => input.value = `${topVariantSku}-${bottomVariantSku}`);
    }
  });

  customElements.define('top-size-picker', class extends HTMLElement {
    initialize(product) {
      this.product = product;

      this.variantIdInput = this.querySelector('[data-top-variant-id]');
      this.variantSkuInput = this.querySelector('[data-top-variant-sku]');

      this.usesBraSizes = this.querySelector('[data-band-size-pill]')
          && this.querySelector('[data-cup-size-pill]');

      if (this.usesBraSizes) {
        this.updateAvailability();
      }

      this.addEventListener('change', event => this.handleChange(event));
    }

    handleChange(event) {
      if (this.usesBraSizes) {
        this.updateAvailability();
      }

      this.changeVariant();
      this.validateInputs();
    }

    updateAvailability() {
      const bandSize = this.querySelector('[data-band-size-pill]:checked')?.value;
      const cupSize = this.querySelector('[data-cup-size-pill]:checked')?.value;

      this.querySelectorAll('[data-band-size-pill]').forEach(bandSizeRadio => {
        let inStockVariant;
        if (cupSize) {
          inStockVariant = this.product.variants
              .find(variant => variant.option1 === `${bandSizeRadio.value}${cupSize}` && variant.available);
        } else {
          inStockVariant = this.product.variants
              .find(variant => variant.option1.startsWith(bandSizeRadio.value) && variant.available);
        }

        bandSizeRadio.disabled = !Boolean(inStockVariant);
      });

      this.querySelectorAll('[data-cup-size-pill]').forEach(cupSizeRadio => {
        let inStockVariant;
        if (bandSize) {
          inStockVariant = this.product.variants
              .find(variant => variant.option1 === `${bandSize}${cupSizeRadio.value}` && variant.available);
        } else {
          inStockVariant = this.product.variants
              .find(variant => {
                const matches = variant.option1.match(/(\d{2})([ABCDGHIJ]{1,3})/);

                return matches[2] && matches[2] === cupSizeRadio.value && variant.available
              });
        }

        cupSizeRadio.disabled = !Boolean(inStockVariant);
      });
    }

    changeVariant() {
      this.variantIdInput.value = '';
      this.variantSkuInput.value = '';

      if (this.usesBraSizes) {
        const bandSize = this.querySelector('[data-band-size-pill]:checked')?.value;
        const cupSize = this.querySelector('[data-cup-size-pill]:checked')?.value;
        if (!bandSize || !cupSize) {
          return;
        }

        const braSize = `${bandSize}${cupSize}`;
        this.product.variants.forEach(variant => {
          if (variant.option1 === braSize) {
            this.variantIdInput.value = variant.id;
            this.variantSkuInput.value = variant.sku;
          }
        });
      } else {
        const topSizeRadio = this.querySelector('[data-top-size-pill]:checked');
        if (topSizeRadio && !topSizeRadio.disabled && !topSizeRadio.classList.contains('disabled')) {
          this.variantIdInput.value = topSizeRadio.value;
          this.variantSkuInput.value = topSizeRadio.dataset.sku;
        }
      }
    }

    validateInputs(showErrors = false) {
      const topVariantId = this.querySelector('[data-top-variant-id]').value;

      if (!topVariantId) {
        if (this.usesBraSizes) {
          const bandSizeError = this.querySelector('[data-band-size-error]');
          const bandSize = this.querySelector('[data-band-size-pill]:checked');
          if (bandSize) {
            bandSizeError.classList.add('hidden');
          } else if (showErrors) {
            bandSizeError.classList.remove('hidden');
          }

          const cupSizeError = this.querySelector('[data-cup-size-error]');
          const cupSize = this.querySelector('[data-cup-size-pill]:checked');
          if (cupSize) {
            cupSizeError.classList.add('hidden');
          } else if (showErrors) {
            cupSizeError.classList.remove('hidden');
          }
        } else if (showErrors) {
          this.querySelector('.form__error-label').classList.remove('hidden');
        }

        return false;
      }

      this.querySelectorAll('.form__error-label')
            .forEach(error => error.classList.add('hidden'));

      return true;
    }
  });

  customElements.define('bottom-size-picker', class extends HTMLElement {
    initialize() {
      this.variantIdInput = this.querySelector('[data-bottom-variant-id]');
      this.variantSkuInput = this.querySelector('[data-bottom-variant-sku]');

      this.addEventListener('change', (event) => this.handleChange(event));
    }

    handleChange(event) {
      this.variantIdInput.value = '';
      this.variantSkuInput.value = '';

      if (event.target.hasAttribute('data-bottom-shape-pill')) {
        this.changeShape();
      } else {
        this.changeVariant();
      }

      this.validateInputs();
    }

    changeShape() {
      const shapeProductId = this.querySelector('[data-bottom-shape-pill]:checked')?.value;

      this.querySelectorAll('[data-bottom-size-pill]').forEach(radioOption => {
        radioOption.checked = false;
        const radioOptionLabel = radioOption.nextElementSibling;

        if (radioOption.dataset.productId === shapeProductId) {
          radioOption.classList.remove('hidden');
          radioOptionLabel.classList.remove('hidden');
        } else {
          radioOption.classList.add('hidden');
          radioOptionLabel.classList.add('hidden');
        }
      });
    }

    changeVariant() {
      const bottomSizeRadio = this.querySelector('[data-bottom-size-pill]:checked');
      if (bottomSizeRadio && !bottomSizeRadio.disabled && !bottomSizeRadio.classList.contains('disabled')) {
        this.variantIdInput.value = bottomSizeRadio.value;
        this.variantSkuInput.value = bottomSizeRadio.dataset.sku;
      }
    }

    validateInputs(showErrors = false) {
      const bottomVariantId = this.querySelector('[data-bottom-variant-id]').value;

      if (!bottomVariantId) {
        if (showErrors) {
          this.querySelector('.form__error-label').classList.remove('hidden');
        }

        return false;
      }

      this.querySelector('.form__error-label').classList.add('hidden');

      return true;
    }
  });

  customElements.define('product-form-initializer', class ProductFormInitializer extends HTMLElement {
    connectedCallback() {
      if (typeof this.parentElement.subtreeLoadedCallback === 'function') {
        this.parentElement.subtreeLoadedCallback();
      }
    }
  });
}
